function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpensifyCardIcon = function SvgExpensifyCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3A1.75 1.75 0 0 0 0 4.75v10.5C0 16.216.784 17 1.75 17h16.5A1.75 1.75 0 0 0 20 15.25V4.75A1.75 1.75 0 0 0 18.25 3H1.75Zm11.249 11.5H7v-9h5.999v2H9V9h3v1.909H9v1.592h4V14.5Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgExpensifyCardIcon;